import { Component, OnInit, Input } from '@angular/core';
import { Thread, Message } from '../message-service/message.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { Store } from '@ngxs/store';
import { MessageRead, ThreadReply, SendMessage, MarkThreadRead } from '../message-store/message.actions';
import { BehaviorSubject, Subject } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';


@Component({
  selector: 'app-message-thread',
  templateUrl: './message-thread.component.html',
  styleUrls: ['./message-thread.component.scss'],
  standalone: false
})
export class MessageThreadComponent implements OnInit {

  @Input() thread: Thread;
  @Input() user: LenderUser;
  @Input() borrower: Borrower;
  @Input() first: boolean;
  @Input() autoMarkRead: boolean;

  messageGroup$: Subject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private store: Store) { }

  ngOnInit(): void {
    const openGroup = this.thread.messages.length > 4 ? true : false;
    this.messageGroup$.next(openGroup);
    const messages = this.thread.messages;
    if(this.autoMarkRead && messages?.length && this.thread.unreadMessageCount) {
      this.markThreadRead();
    }
  }

  hasMultipleMessages(thread: Thread) {
    return thread && thread.messages.length > 1 ? true : false;
  }

  isRead(thread: Thread) {
    return !thread.messages?.some(x => !x.read);
  }

  trackById(model: any) {
    return model.id;
  }

  isToday(createdTimeStamp) {
    const timestampDate = new Date(createdTimeStamp * 1000);
    const today = new Date();
    return (today.getDate() === timestampDate.getDate()
      && today.getMonth() === timestampDate.getMonth()
      && today.getFullYear() === timestampDate.getFullYear());
  }

  handleEmailCreate(message: Message): void {
    message.threadId ? this.store.dispatch(new ThreadReply(message.threadId, message)) : this.store.dispatch(new SendMessage(message));
  }

  handleMessageRead(message: Message): void {
    if (
      this.user.id === this.borrower.userId
      && message
      && message.id
      && message.read === null
    ) {
      this.store.dispatch(new MessageRead(message));
    }
  }

  markThreadRead() {
    this.store.dispatch( new MarkThreadRead(this.thread.id) );
  }

  openMessageGroup() {
    this.messageGroup$.next(false);
  }

  expansionPanelTitle(thread: Thread) {
    if (this.isRead(thread)) {
      if (this.hasMultipleMessages(thread)) {
        return 'Multiple Read Messages';
      } else {
        return 'One Read Message';
      }
    } else {
      if (this.hasMultipleMessages(thread)) {
        return 'Multiple Unread Messages';
      } else {
        return 'One Unread Message';
      }
    }
  }

  expansionPanelDescription(thread: Thread) {
    if (thread && thread.messages && thread.messages.length > 1) {
      if (thread.messages[0].recipientCount === 0) {
        return 'Multiple Emails Missing Recipients';
      } else {
        return 'Multiple Emails';
      }
    } else if (thread && thread.messages && thread.messages.length === 1) {
      if (thread.messages[0]?.hubspotEmailTemplateId) {
        return 'Marketing Email';
      } else {
        if (thread.messages[0]?.recipientCount === 0) {
          return 'Missing Recipients';
        } else {
          return 'Single Non-Marketing Email';
        }
      }
    }
  }

}
